import { createContext } from "react";

import { AssetListingConfig } from "../../common/config/AssetListingConfig";
import { SingleMovie } from "./SingleMovie";

interface ISingleMovieContext {
    movieId: string;
    movie: SingleMovie;
    isLoading: boolean;
    listingConfig: AssetListingConfig;
    saveListingConfig: (config: AssetListingConfig) => void;
}

const defaultSingleMovieContext: ISingleMovieContext = {} as ISingleMovieContext;

export const SingleMovieContext = createContext<ISingleMovieContext>(defaultSingleMovieContext);
